<ng-container *ngFor="let button of actionBar.buttons">
  <div
    *ngIf="button.action"
    [attr.data-testid]="'action-bar-button-'.concat(button.label.toLowerCase().split(' ').join('-'))"
    [matTooltip]="button.tooltip"
    class="action-button-tooltip"
    matTooltipPosition="above"
  >
    <button
      (click)="button.action()"
      [class.main]="button.primary"
      [disabled]="button | function: isButtonDisabled"
      class="action-button"
    >
      <span *ngIf="button.icon" [inlineSVG]="button.icon"></span>
      <span>{{ button.label }}</span>
    </button>
  </div>

  <div
    *ngIf="button.routerLink"
    [attr.data-testid]="'action-bar-button-'.concat(button.label.toLowerCase().split(' ').join('-'))"
    [matTooltip]="button.tooltip"
    class="action-button-tooltip"
    matTooltipPosition="above"
  >
    <a
      [class.disabled]="button | function: isButtonDisabled"
      [class.main]="button.primary"
      (click)="navigateTo(button)"
      class="action-button"
    >
      <div *ngIf="button.icon" [inlineSVG]="button.icon"></div>
      <span>{{ button.label }}</span>
    </a>
  </div>
</ng-container>

<ng-container *ngIf="actionBar.menu && actionBar.menu.length">
  <button
    [matMenuTriggerFor]="menu"
    class="action-button menu-trigger"
    data-testid="overview-card-menu"
    inlineSVG="/assets/icons/more-vert.svg"
    role="button"
  ></button>
  <mat-menu #menu="matMenu">
    <ng-container *ngFor="let menuItem of actionBar.menu">
      <button mat-menu-item *ngIf="menuItem.action" (click)="menuItem.action()">{{ menuItem.label }}</button>
      <a mat-menu-item *ngIf="menuItem.routerLink" (click)="navigateTo(menuItem)">{{ menuItem.label }}</a>
    </ng-container>
  </mat-menu>
</ng-container>
